import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { DynamicInput, DashboardModule } from '@domain-group/suit-theme'

import searchEndpoint from '@functions/search'

import EntitySelector from '@components/EntitySelector'

const supportedComponents = {
  DynamicInput,
  EntitySelector,
}

const DashboardModuleFilters = (props) => {
  const { callbacks, ...restProps } = props

  const entities = useSelector(reduxState => reduxState.entities)

  return (
    <DashboardModule.Filters
      callbacks={{ ...callbacks, searchEndpoint }}
      entities={entities}
      supportedComponents={supportedComponents}
      {...restProps}
    />
  )
}

DashboardModuleFilters.propTypes = {
  callbacks: PropTypes.shape({
    updateFilters: PropTypes.func.isRequired,
  }).isRequired,
  filterFields: PropTypes.array.isRequired,
  pageFilters: PropTypes.object.isRequired,
}

export default DashboardModuleFilters
